var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCryptoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63996 0.333496H0.699933C0.0799334 0.333496 -0.233393 1.08683 0.206607 1.52683L4.02659 5.34683C5.11993 6.44016 6.88659 6.44016 7.97992 5.34683L11.7999 1.52683C12.24 1.08683 11.9266 0.333496 11.3066 0.333496H10.3666C9.81327 0.333496 9.27995 0.553496 8.88662 0.946829L6.49994 3.3335C6.22661 3.60683 5.78662 3.60683 5.51329 3.3335L3.12661 0.946829C2.72661 0.553496 2.19329 0.333496 1.63996 0.333496Z",
    fill: "#0057FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.63996 13.6468H0.699933C0.0799334 13.6468 -0.233393 12.8935 0.206607 12.4535L4.02659 8.6335C5.11993 7.54016 6.88659 7.54016 7.97992 8.6335L11.7999 12.4535C12.24 12.8935 11.9266 13.6468 11.3066 13.6468H10.3666C9.81327 13.6468 9.27995 13.4268 8.88662 13.0335L6.49994 10.6468C6.22661 10.3735 5.78662 10.3735 5.51329 10.6468L3.12661 13.0335C2.72661 13.4268 2.19329 13.6468 1.63996 13.6468Z",
    fill: "#0057FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptoIcon);
export default __webpack_public_path__ + "static/media/crypto-icon.901cac3bc4b04252b2e0a48fe6e12951.svg";
export { ForwardRef as ReactComponent };